export const QUERY_KEY = {
  FORM_TOKEN: 'form_token',
  VERIFICATION_CODE: 'verification_code',
  ORGANIZATIONS: 'organizations',
  ORGANIZATION_CONTENT: 'organization_content',
  USER_DETAILS: 'user_details',
}
